
namespace TabAurous.Reports {
    export class MonthlyReportOptions {
        items: Sales.SalesItemsRow[];
    }

    export class MonthlyReportPanel extends Serenity.TemplatedPanel<WeeklyReportOptions> {
        constructor(container: JQuery, opt: WeeklyReportOptions) {
            super(container, opt);

            //Grouping
            var data: Sales.SalesItemsRow[] = this.options.items;
            //var code = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            var pieces = [0];
            pieces.pop();
            var sales = [0];
            sales.pop();
            var week1p = 0, week2p = 0; var week3p = 0, week4p = 0;
            var week1s = 0, week2s = 0; var week3s = 0, week4s = 0;
            for (var i = 0; i < data.length; i++) {
                week1p += data[i].Week1Pieces;
                week2p += data[i].Week2Pieces;
                week3p += data[i].Week3Pieces;
                week4p += data[i].Week4Pieces;
                week1s += data[i].Week1Sales;
                week2s += data[i].Week2Sales;
                week3s += data[i].Week3Sales;
                week4s += data[i].Week4Sales;
            }
            var _week1s = parseFloat( week1s.toFixed(2));
            var _week2s = parseFloat(week2s.toFixed(2));
            var _week3s = parseFloat(week3s.toFixed(2));
            var _week4s = parseFloat( week4s.toFixed(2));
            pieces.push(week1p); pieces.push(week2p); pieces.push(week3p); pieces.push(week4p);
            sales.push(_week1s); sales.push(_week2s); sales.push(_week3s); sales.push(_week4s);
            var options = {
                series: [{
                    name: 'Sales',
                    type: 'column',
                    data: sales
                }, {
                    name: 'Pieces',
                    type: 'line',
                    data: pieces
                }],
                chart: {
                    height: 250,
                    type: 'line',
                },
                stroke: {
                    width: [0, 4]
                },
                title: {
                    text: 'Monthly Sales'
                },
                dataLabels: {
                    enabled: true,
                    enabledOnSeries: [1]
                },
                labels: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
                xaxis: {
                    type: 'text'
                },
                yaxis: [{
                    title: {
                        text: 'Gross Sales',
                    },

                }, {
                    opposite: true,
                    title: {
                        text: 'Total Pieces'
                    }
                }]
            };
            //var x = document.getElementById('TabAurous_Reports_ChartPanel13_chartContainer');
            var y = container[0].childNodes[0];
            var chart = new ApexCharts(y, options);

            chart.render();
        }

        getTemplate() {

            return `<div id="~_chartContainer"></div>`;
        }
    }

    @Serenity.Decorators.registerClass()
    export class MonthlyReportEditor extends _Ext.GridEditorBase<Sales.SalesItemsRow> {
        protected getColumnsKey() { return "Sales.MonthlySales"; }
 

        private chartContainer: JQuery;
        private chartPanel: MonthlyReportPanel;
        constructor(container: JQuery) {
            super(container);


        } 

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid(); 

            //var plugin = new Slick.ColumnGroup();
            //grid.registerPlugin(plugin);
            //var columns = grid.getColumns();

            ////grid.registerPlugin(new Slick.columng);

            //for (let col of columns) {
            //    //console.log(col);
            //    if (col.field == "Month") col.groupName = "Month";

            //    if (col.field == "Week1Pieces" || col.field == "Week1Sales") col.groupName = "Week 1";
            //    if (col.field == "Week2Pieces" || col.field == "Week2Sales") col.groupName = "Week 2";
            //    if (col.field == "Week3Pieces" || col.field == "Week3Sales") col.groupName = "Week 3";
            //    if (col.field == "Week4Pieces" || col.field == "Week4Sales") col.groupName = "Week 4";
            //}

            //plugin.enableColumnGrouping();

            //grid.setColumns(columns); 
            //grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            return grid;
        }
        public setdata(items: Sales.SalesItemsRow[], response) {
            this.setItems([]);
            for (let item of items) {
                item[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(item);

            }

            this.onViewProcessData(response);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            return buttons;
        } 
        onViewProcessData(response: Serenity.ListResponse<Sales.SalesItemsRow>) {

            if (!this.chartContainer) {
                this.chartContainer = $("<div style='padding: 20px 0' />");
                this.chartContainer.insertBefore(this.element.find(".grid-container"));
            }

            if (this.chartPanel) {
                this.chartPanel.destroy();
            }

            this.chartPanel = new MonthlyReportPanel(this.chartContainer, { items: response.Entities });


            return response;
        }
    }
}